import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Row, Col, Form } from "react-bootstrap";
import Footer from "./footer";
import Header from "./header";
import { Link } from "react-router-dom";
import moment from "moment";
import { studentlistAttendance, studentview, teacherview, transportattendancelist } from "../service/dashboard";
import { toast } from "react-toastify";

const MyAttendance = () => {
    const [attendanceData, setAttendanceData] = useState({});
    const [classId, setClassId] = useState(null);
    const [academyId, setAcademyId] = useState(null);
    const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };

    useEffect(() => {
        if (localStorage.getItem("Role") === "4") {
            studentview(localStorage.getItem("UID")).then((res1) => {
                if (res1.status === true) {
                    setClassId(res1.data.details.class_id);
                    setAcademyId(res1.data.details.academy_id);

                    const startDate = moment().startOf("month").format("YYYY-MM-DD");
                    const endDate = moment().endOf("month").format("YYYY-MM-DD");

                    fetchAttendance(startDate, endDate, res1.data.details.class_id, res1.data.details.academy_id);
                }
            });
        } else if (localStorage.getItem("Role") === "5") {
            teacherview(localStorage.getItem("UID")).then((res1) => {
                if (res1.status === true) {
                    setClassId(res1.data.details.inc_class);
                    setAcademyId(res1.data.details.academy_id);

                    const startDate = moment().startOf("month").format("YYYY-MM-DD");
                    const endDate = moment().endOf("month").format("YYYY-MM-DD");

                    fetchAttendance(startDate, endDate, res1.data.details.inc_class, res1.data.details.academy_id);
                }
            });
        } else if (localStorage.getItem("Role") === "9" || localStorage.getItem("Role") === "6") {
            // Driver/worker attendance lives in the vehicle_driver table.
            setAcademyId(localStorage.getItem("academy"));
            const startDate = moment().startOf("month").format("YYYY-MM-DD");
            const endDate = moment().endOf("month").format("YYYY-MM-DD");
            fetchDriverAttendance(startDate, endDate);
        }

    }, []);

    const fetchDriverAttendance = (startDate, endDate) => {
        const temp = new FormData();
        temp.append("from_date", startDate);
        temp.append("to_date", endDate);
        temp.append("user_id", localStorage.getItem("UID"));
        transportattendancelist(temp).then((res) => {
            if (res && res.status === true && res.data.details.length > 0) {
                const attendanceMap = {};
                res.data.details.forEach((item) => {
                    const date = item.attendance_date;
                    let session = item.attendance_time ? item.attendance_time.toLowerCase() : "morning";
                    if (session === "afternoon") session = "evening";
                    const status = item.attend_status == 1 ? "present" : "absent";
                    if (!attendanceMap[date]) attendanceMap[date] = {};
                    attendanceMap[date][session] = status;
                });
                setAttendanceData(attendanceMap);
            } else {
                setAttendanceData({});
            }
        });
    };
    const fetchAttendance = (startDate, endDate, lcls, aca) => {
        studentlistAttendance(startDate, endDate, lcls, aca, localStorage.getItem("UID")).then((res) => {
            if (res.status === true) {
                const attendanceMap = {};

                res.data.forEach((item) => {
                    const date = item.attendance_date;
                    // second slot may be stored as legacy "afternoon" or current "evening"
                    let session = item.attendance_time.toLowerCase(); // "morning" / "evening" / "afternoon"
                    if (session === "afternoon") session = "evening";
                    const status = item.attend_status === 1 ? "present" : "absent";

                    if (!attendanceMap[date]) {
                        attendanceMap[date] = {};//morning: "absent", evening: "absent"
                    }

                    attendanceMap[date][session] = status;
                });
                // Always reset to the selected month's data — empty {} clears the
                // counts when the month has no records instead of keeping stale ones.
                setAttendanceData(attendanceMap);
            } else {
                setAttendanceData({});
                toast.error(res.message);
            }
        });
    };

    const handleMonthChange = ({ activeStartDate, view }) => {
        if (view !== "month" || !academyId) return;
        const startDate = formatDate(activeStartDate);
        const endDate = formatDate(new Date(activeStartDate.getFullYear(), activeStartDate.getMonth() + 1, 0));
        const role = localStorage.getItem("Role");
        if (role === "4" && classId) {
            fetchAttendance(startDate, endDate, classId, academyId);
        } else if (role === "5") {
            fetchAttendance(startDate, endDate, 0, academyId);
        } else if (role === "9" || role === "6") {
            fetchDriverAttendance(startDate, endDate);
        }
    };

    const tileContent = ({ date, view }) => {
        if (view !== "month") return null;
        const key = formatDate(date);
        const day = attendanceData[key];
        if (!day) return null;

        return (
            <div className="attendance-dots">
                {day.morning && (
                    <span
                        className={`dot ${day.morning === "present" ? "present" : "absent"}`}
                        title={`Morning: ${day.morning}`}
                    >
                        {day.morning === "present" ? "P" : "A"}
                    </span>
                )}
                {day.evening && (
                    <span
                        className={`dot ${day.evening === "present" ? "present" : "absent"}`}
                        title={`Evening: ${day.evening}`}
                    >
                        {day.evening === "present" ? "P" : "A"}
                    </span>
                )}
            </div>

        );
    };

    const totalDays = Object.keys(attendanceData).length;
    const presentCount = Object.values(attendanceData).filter(
        (d) => d.morning === "present" || d.evening === "present"
    ).length;
    // const absentCount = Object.values(attendanceData).filter(
    //     (d) => d.morning === "absent" && d.evening === "absent"
    // ).length;
    const absentCount = Object.values(attendanceData).reduce((total, d) => {
    const morningAbsent = d.morning === "absent";
    const eveningAbsent = d.evening === "absent";

    if (morningAbsent && eveningAbsent) {
        return total + 1; // full day absent
    } else if (morningAbsent || eveningAbsent) {
        return total + 0.5; // half day absent
    }
    return total;
}, 0);

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">

                        {localStorage.getItem("Role") == "5" ? (
                            <>
                                <Col xs={4} className="text-left align-self-end">
                                    <h4 className="morehead-text">My Attendance</h4>
                                </Col>
                                {/* <Col xs={4} className="text-right align-self-end">
                                    <Link to={"/addattendance"} className="btn-outline-success green-btn btn-sm">
                                        <i className="fa-solid fa fa-plus-square"></i> Add
                                    </Link>
                                </Col> */}
                            </>
                        ) : <Col xs={8} className="text-left align-self-end">
                            <h4 className="morehead-text">My Attendance</h4>
                        </Col>
                        }

                        <Col xs={4} className="text-right align-self-end">
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                </div>

                <div className="counts-wrapper col-sm-4 ">
                    <div className="count-box total">
                        <div className="number">{totalDays}</div>
                        <div className="label">Total Days</div>
                    </div>
                    <div className="count-box present col-sm-4">
                        <div className="number">{presentCount}</div>
                        <div className="label">Present</div>
                    </div>
                    <div className="count-box absent col-sm-4">
                        <div className="number">{absentCount}</div>
                        <div className="label">Absent</div>
                    </div>
                </div>
                <div className="mb-4">
                    <Calendar tileContent={tileContent} onActiveStartDateChange={handleMonthChange} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MyAttendance;
